
import SlTab from '@shoelace-style/shoelace/dist/react/tab';
import SlTabGroup from '@shoelace-style/shoelace/dist/react/tab-group';
import SlTabPanel from '@shoelace-style/shoelace/dist/react/tab-panel';
//import SlCard from '@shoelace-style/shoelace/dist/react/card';
import { useNavigate } from 'react-router-dom';
import Home from "./Home.js";
import Currentprojects from "./Currentprojects.js";
//import AboutUs from "./Aboutus.js";
import React, { useState } from 'react';
import SlButton from '@shoelace-style/shoelace/dist/react/button';
import SlInput from '@shoelace-style/shoelace/dist/react/input';
import SlDialog from '@shoelace-style/shoelace/dist/react/dialog';


const css = `
  .app {
    text-align: center;
    padding: 1vw;
  }
  .form-content {
    text-align: left;
    padding: '0 1rem';
}

  .app-header {
    text-align: right;
    border-bottom: 1px solid lightgray;
    gap: 17px;
    display: flex;
    flex-direction: column;
    justify-content: end;
  }

  .app-header-left {
    text-align: right;
    gap: 17px;
    display: flex;
    flex-direction: row;
    justify-content: end;
  }
  .app-header-left > img {
    width: 93px;
    margin-bottom: 15px;
  }

  @media screen and (min-width: 900px) {
    .app-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .app-header-right {
          text-align: right;
          gap: 17px;
          display: flex;
          flex-direction: row;
          justify-content: end;
      }
    }
  }
  sl-dialog {
    sl-input {
        margin: 35px 0px;
      }
  }

  sl-tab-group::part(tabs) {
    --track-width: 5px;
  }

  sl-tab-panel::part(base) {
   padding: 50px;
  }

  .card-image-profile {
    min-width: 200px;
    padding: 20px;
    max-width: 250px;
    border: 2px solid var(--sl-color-gray-300);
    margin: 1vw;
  }
`;

function App() {
    const navigate = useNavigate();

    const [credentials, setCredentials] = useState({ username: "", password: "" });
  
    const handleChange = (e) => {
      setCredentials({ ...credentials, [e.target.name]: e.target.value });
    };
  

    // CHANGE BELOW FOR LOGIN PAGE APPROACH
    const handleSubmit = async (e) => {
      e.preventDefault();
      // Simulate API call
      if (credentials.username === 'user' && credentials.password === 'password') {
        localStorage.setItem('authToken', 'your-jwt-token'); // Store token
        navigate('/'); // Redirect to dashboard
      } else {
        alert('Invalid credentials');
      }
    };
  

  return (
    <div className="app">
      <header className="app-header">
      <div className="app-header-left">
      <img
            slot="image"
            src="./images/LogoSerale.png"
            alt="JADU."
          />
      <SlButton variant="primary" onClick={() => navigate('/')}>
          Maintenance & Repair Portal
        </SlButton>
        </div>

        <div className="app-header-right">

       
         
          </div>
      </header>
      <SlTabGroup>
       {/*  <SlTab slot="nav" panel="tab-0">
          Home
        </SlTab> */}

        <SlTab slot="nav" panel="tab-2">
          Current Projects
        </SlTab>

      {/* <SlTab slot="nav" panel="tab-4">
          About Us
        </SlTab> */}

       {/*  <SlTabPanel name="tab-0">
          <Home />
        </SlTabPanel> */}

        <SlTabPanel name="tab-2">
          <Currentprojects />
        </SlTabPanel>
       
       {/*  <SlTabPanel name="tab-4">
          <AboutUs />
        </SlTabPanel> */}
      </SlTabGroup>
      <style>{css}</style>
    </div>
  );
}

export default App;
